import React from 'react';

import { CalculationDataByKeysInterface } from 'app/shared/interfaces/CalculationDataByKeys.interface';
import { LabelEnum, VehicleTypeEnum } from 'app/shared/enums';
import { useForm } from 'app/shared/hooks/useForm';
import { CarSelectControlTooltipProps } from './CarSelectControlTooltip.interface';

function CarSelectControlTooltip(props: CarSelectControlTooltipProps) {
  const { formName } = props;

  const { formValues } = useForm<CalculationDataByKeysInterface>(formName);

  const isMotor = formValues.vehicleType === VehicleTypeEnum.Motorcycle;

  return (
    <>
      <h4>{LabelEnum.VehicleData}:</h4>
      <div className="content">
        <p>
          {LabelEnum.NewCarSelectDescription1}
          {!isMotor && LabelEnum.NewCarSelectDescription2}
        </p>
      </div>
    </>
  );
}

export default CarSelectControlTooltip;
